<!--
 * @Author: Christion.Young
 * @Date: 2024-10-22 14:56:06
 * @LastEditors: Christion.Young
 * @LastEditTime: 2024-10-29 23:31:27
 * @Description: 平台相关页面 - 简洁设计，核心信息展示
 * @Version: v2.0
-->
<template>
  <div class="about-platform-page">
    <div class="about-page-container">
      <!-- 平台简介 -->
      <section class="about-platform-intro">
        <div class="about-intro-card">
          <div class="about-intro-header">
            <i class="el-icon-info"></i>
            <span>企业简介</span>
          </div>
          <div class="about-intro-content">
            <p>
              成都菁融智汇信息科技有限公司是一家以产品+服务为主线、集成为辅的技术型公司，公司采用合伙人机制，核心团队成员具有中电科、华为、中兴等大型企业经历，在产品设计研发、解决方案和项目实施等方面有丰富经验。运营专业的私人服务在线平台--三火私服。
            </p>
            <div class="about-service-tags">
              <span class="about-tag">技术型公司</span>
              <span class="about-tag">合伙人机制</span>
              <span class="about-tag">丰富经验</span>
              <span class="about-tag">专业服务</span>
            </div>
          </div>
        </div>
      </section>

      <!-- 企业服务 -->
      <section class="about-services-section">
        <div class="about-section-title">
          <i class="el-icon-s-grid"></i>
          <span>企业服务</span>
        </div>

        <!-- 三火私服平台 -->
        <div class="about-service-card about-primary-service">
          <div class="about-service-header">
            <div class="about-service-number">1</div>
            <h3>三火私服--专业私人服务在线开放平台</h3>
          </div>
          <div class="about-service-content">
            <p class="about-service-desc">
              整合具有专业技能和时间的人，为客户提供高品质的专业服务。只要您有技能、有时间入驻平台进行价值变现，加入平台推广计划，分享您的推广码，享三级分佣！
            </p>
            <div class="about-service-categories">
              <div class="about-category-grid">
                <span class="about-category-item">私人陪护</span>
                <span class="about-category-item">老人护理</span>
                <span class="about-category-item">私人陪诊</span>
                <span class="about-category-item">私人医生</span>
                <span class="about-category-item">私人厨师</span>
                <span class="about-category-item">私人安保</span>
                <span class="about-category-item">私人理财</span>
                <span class="about-category-item">私人律师</span>
                <span class="about-category-item">私人美妆美容</span>
                <span class="about-category-item">软件开发</span>
                <span class="about-category-item">家庭维修</span>
                <span class="about-category-item">保洁归纳</span>
                <span class="about-category-item">家电清洗</span>
                <span class="about-category-item">私人导游地陪</span>
                <span class="about-category-item">按摩理疗</span>
                <span class="about-category-item">商务公关</span>
                <span class="about-category-item">游戏陪练</span>
                <span class="about-category-item">辅导培训</span>
                <span class="about-category-item">宠物服务</span>
                <span class="about-category-item">工商财税代办</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 其他服务 -->
        <div class="about-other-services">
          <div class="about-service-item">
            <div class="about-service-number">2</div>
            <div class="about-service-info">
              <h4>软件开发及人力外包服务</h4>
              <p>提供专业的软件开发和人力资源外包解决方案</p>
            </div>
          </div>

          <div class="about-service-item">
            <div class="about-service-number">3</div>
            <div class="about-service-info">
              <h4>信息系统集成、运维服务</h4>
              <p>专业的系统集成和运维管理服务</p>
            </div>
          </div>

          <div class="about-service-item">
            <div class="about-service-number">4</div>
            <div class="about-service-info">
              <h4>安全保密、科技申报咨询服务</h4>
              <p>提供安全保密和科技项目申报专业咨询</p>
            </div>
          </div>
        </div>
      </section>

      <!-- 服务案例 -->
      <section class="about-cases-section">
        <div class="about-section-title">
          <i class="el-icon-trophy"></i>
          <span>服务案例</span>
        </div>

        <div class="about-cases-grid">
          <!-- 系统集成案例 -->
          <div class="about-case-category">
            <div class="about-case-header">
              <div class="about-case-icon">
                <i class="el-icon-connection"></i>
              </div>
              <h3>系统集成</h3>
            </div>
            <div class="about-case-list">
              <div class="about-case-item">省边防检查总站某工程改造项目</div>
              <div class="about-case-item">达州宣汉巡察办某网系统集成</div>
              <div class="about-case-item">巴中经开区某专网系统集成项目</div>
              <div class="about-case-item">遂宁大英县某系统密改项目</div>
            </div>
          </div>

          <!-- 软件开发案例 -->
          <div class="about-case-category">
            <div class="about-case-header">
              <div class="about-case-icon">
                <i class="el-icon-cpu"></i>
              </div>
              <h3>软件开发</h3>
            </div>
            <div class="about-case-list">
              <div class="about-case-item">巴中市某数据联动预警系统</div>
              <div class="about-case-item">鲜言社区水果团购定制项目</div>
              <div class="about-case-item">蜀道某隧道卫星定位科研项目</div>
              <div class="about-case-item">服务商城平台项目</div>
            </div>
          </div>

          <!-- 技术服务案例 -->
          <div class="about-case-category">
            <div class="about-case-header">
              <div class="about-case-icon">
                <i class="el-icon-s-tools"></i>
              </div>
              <h3>技术服务</h3>
            </div>
            <div class="about-case-list">
              <div class="about-case-item">省交通运输厅某方案咨询设计</div>
              <div class="about-case-item">省文联信某方案咨询设计</div>
              <div class="about-case-item">
                四川某公司计算机保密检查服务项目
              </div>
              <div class="about-case-item">
                成都市交通运输局门户网站内容日常检测服务项目
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 联系我们 -->
      <section class="about-contact-section">
        <div class="about-section-title">
          <i class="el-icon-phone"></i>
          <span>联系我们</span>
        </div>

        <div class="about-contact-content">
          <div class="about-contact-desc">
            <p>业务合作 | 推广合作 | 加入我们</p>
          </div>

          <div class="about-contact-grid">
            <div class="about-contact-item">
              <div class="about-contact-icon">
                <i class="el-icon-link"></i>
              </div>
              <div class="about-contact-info">
                <div class="about-contact-label">公司网址</div>
                <div class="about-contact-value">www.sanhsf.com</div>
              </div>
            </div>

            <div class="about-contact-item">
              <div class="about-contact-icon">
                <i class="el-icon-message"></i>
              </div>
              <div class="about-contact-info">
                <div class="about-contact-label">联系邮箱</div>
                <div class="about-contact-value">3684877060@qq.com</div>
              </div>
            </div>

            <div class="about-contact-item">
              <div class="about-contact-icon">
                <i class="el-icon-service"></i>
              </div>
              <div class="about-contact-info">
                <div class="about-contact-label">服务号</div>
                <div class="about-contact-value">三火私服</div>
              </div>
            </div>

            <div class="about-contact-item">
              <div class="about-contact-icon">
                <i class="el-icon-mobile-phone"></i>
              </div>
              <div class="about-contact-info">
                <div class="about-contact-label">小程序</div>
                <div class="about-contact-value">三火私服</div>
              </div>
            </div>
          </div>

          <!-- 二维码区域 -->
          <div class="about-qr-section">
            <div class="about-qr-item">
              <div class="about-qr-image">
                <img src="@/assets/serviceNumber.jpg" alt="微信服务号二维码" />
              </div>
              <div class="about-qr-label">微信搜索"三火私服"</div>
              <div class="about-qr-desc">关注官方服务号</div>
            </div>

            <div class="about-qr-item">
              <div class="about-qr-image">
                <img src="@/assets/miniprogram-qr.png" alt="小程序二维码" />
              </div>
              <div class="about-qr-label">扫码使用小程序</div>
              <div class="about-qr-desc">便捷服务入口</div>
            </div>

            <div class="about-qr-item">
              <div class="about-qr-image">
                <img
                  src="@/assets/WechatCustomerservice.png"
                  alt="小程序二维码"
                />
              </div>
              <div class="about-qr-label">微信客服</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Platform",
  data() {
    return {
      // 相关文档列表
      documentList: [
        {
          name: "隐私协议",
          description: "用户隐私保护协议",
          url: "https://admin.sanhsf.com/images/三火私服隐私协议.pdf",
          filename: "隐私协议.pdf",
        },
        {
          name: "服务协议",
          description: "用户服务协议条款",
          url: "https://admin.sanhsf.com/images/三火私服服务协议.pdf",
          filename: "服务协议.pdf",
        },
        {
          name: "平台规则",
          description: "平台使用规则说明",
          url: "https://admin.sanhsf.com/images/三火私服平台规则.pdf",
          filename: "平台规则.pdf",
        },
        {
          name: "用户手册",
          description: "平台使用指南手册",
          url: "https://admin.sanhsf.com/images/三火私服用户手册.pdf",
          filename: "用户手册.pdf",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      platformInfo: (state) => state.user.platform || {},
    }),

    // 获取资质图片URL
    qualificationUrl() {
      return (
        this.platformInfo.qualificationUrl ||
        "https://admin.sanhsf.com/images/平台资质.jpg"
      );
    },
  },
  methods: {
    // 预览平台资质
    previewQualification() {
      try {
        // 创建图片预览
        const img = new Image();
        img.onload = () => {
          const newWindow = window.open("", "_blank");
          if (!newWindow) {
            return;
          }

          newWindow.document.write(`
            <html>
              <head>
                <title>平台资质证书</title>
                <style>
                  body { 
                    margin:0; 
                    padding:20px; 
                    text-align:center; 
                    background:#f5f5f5; 
                    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", SimSun, sans-serif;
                  }
                  h2 { 
                    color:#333; 
                    margin-bottom:20px; 
                    font-size: 24px; 
                    font-weight: 600;
                  }
                  img { 
                    max-width:100%; 
                    height:auto; 
                    box-shadow:0 4px 12px rgba(0,0,0,0.15); 
                    border-radius:8px; 
                    margin: 20px 0;
                  }
                  .footer {
                    margin-top: 30px;
                    color: #666;
                    font-size: 14px;
                  }
                </style>
              </head>
              <body>
                <h2>平台资质证书</h2>
                <img src="${
                  this.qualificationUrl
                }" alt="平台资质证书" onload="console.log('证书加载成功')">
                <div class="footer">
                  <p>如需了解更多信息，请联系客服：${
                    this.platformInfo.phone || "400-123-4567"
                  }</p>
                </div>
              </body>
            </html>
          `);
          newWindow.document.close();
        };

        img.onerror = () => {
          console.error("资质图片加载失败");
        };

        img.src = this.qualificationUrl;
      } catch (error) {
        console.error("预览资质证书失败:", error);
      }
    },

    // 查看文档
    viewDocument(doc) {
      try {
        // 检查URL是否有效
        if (!doc.url) {
          console.error("文档链接无效");
          return;
        }

        // 验证URL格式
        try {
          new URL(doc.url);
        } catch {
          console.error("文档链接格式不正确");
          return;
        }

        // 在新窗口中打开文档
        const newWindow = window.open(doc.url, "_blank");
        if (!newWindow) {
          console.error("弹出窗口被阻止");
        }
      } catch (error) {
        console.error("查看文档失败:", error);
      }
    },

    // 设置页面SEO信息
    setPageMeta() {
      document.title = "关于我们 - 成都菁融智汇信息科技有限公司 - 三火私服";

      // 设置页面描述
      const metaDescription = document.querySelector(
        'meta[name="description"]'
      );
      if (metaDescription) {
        metaDescription.setAttribute(
          "content",
          "成都菁融智汇信息科技有限公司，专业私人服务在线平台三火私服，提供私人陪护、老人护理、私人医生、软件开发、系统集成等专业服务"
        );
      }

      // 设置关键词
      const metaKeywords = document.querySelector('meta[name="keywords"]');
      if (metaKeywords) {
        metaKeywords.setAttribute(
          "content",
          "成都菁融智汇,三火私服,私人服务,软件开发,系统集成,私人陪护,老人护理,私人医生,技术服务"
        );
      }
    },
  },

  mounted() {
    // 页面加载完成
    this.setPageMeta();
  },
};
</script>

<style lang="scss" scoped>
.about-platform-page {
  min-height: 100vh;
  background: #f8f9fa;
}

// 页面容器
.about-page-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;

  @media (max-width: 768px) {
    padding: 15px;
  }
}

// 平台简介
.about-platform-intro {
  margin-bottom: 30px;
}

.about-intro-card {
  background: white;
  border-radius: 12px;
  padding: 25px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid #f0f0f0;
}

.about-intro-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
  font-size: 16px;
  font-weight: 600;
  color: #333;

  i {
    color: #ff4840;
    font-size: 18px;
  }
}

.about-intro-content {
  p {
    color: #666;
    line-height: 1.6;
    margin-bottom: 15px;
    font-size: 14px;
  }
}

.about-service-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.about-tag {
  background: linear-gradient(135deg, #ff4840, #fb8681);
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

// 企业服务区域
.about-services-section {
  margin-bottom: 30px;
}

.about-service-card {
  background: white;
  border-radius: 12px;
  padding: 25px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid #f0f0f0;
}

.about-primary-service {
  border-left: 4px solid #ff4840;
}

.about-service-header {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 15px;

  h3 {
    color: #333;
    font-size: 16px;
    font-weight: 600;
    margin: 0;
  }
}

.about-service-number {
  width: 28px;
  height: 28px;
  background: linear-gradient(135deg, #ff4840, #fb8681);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  flex-shrink: 0;
}

.about-service-content {
  .about-service-desc {
    color: #666;
    line-height: 1.6;
    margin-bottom: 20px;
    font-size: 14px;
  }
}

.about-service-categories {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 15px;
}

.about-category-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 8px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    gap: 6px;
  }
}

.about-category-item {
  background: white;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  text-align: center;
  color: #666;
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;

  &:hover {
    background: #ff4840;
    color: white;
    border-color: #ff4840;
    transform: translateY(-1px);
  }
}

.about-other-services {
  display: grid;
  gap: 15px;
}

.about-service-item {
  background: white;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid #f0f0f0;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  }
}

.about-service-info {
  flex: 1;

  h4 {
    color: #333;
    font-size: 14px;
    font-weight: 600;
    margin: 0 0 5px 0;
  }

  p {
    color: #666;
    font-size: 12px;
    margin: 0;
    line-height: 1.4;
  }
}

// 服务案例区域
.about-cases-section {
  margin-bottom: 30px;
}

.about-cases-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 15px;
  }
}

.about-case-category {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid #f0f0f0;
}

.about-case-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 15px;
  padding-bottom: 12px;
  border-bottom: 2px solid #f8f9fa;

  h3 {
    color: #333;
    font-size: 15px;
    font-weight: 600;
    margin: 0;
  }
}

.about-case-icon {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #ff4840, #fb8681);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  i {
    color: white;
    font-size: 14px;
  }
}

.about-case-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.about-case-item {
  color: #666;
  font-size: 13px;
  line-height: 1.4;
  padding: 8px 12px;
  background: #f8f9fa;
  border-radius: 6px;
  border-left: 3px solid #ff4840;
  transition: all 0.3s ease;

  &:hover {
    background: #ff4840;
    color: white;
    transform: translateX(5px);
  }
}

// 联系我们区域
.about-contact-section {
  margin-bottom: 30px;
}

.about-contact-content {
  background: white;
  border-radius: 12px;
  padding: 25px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid #f0f0f0;
}

.about-contact-desc {
  text-align: center;
  margin-bottom: 25px;

  p {
    color: #666;
    font-size: 14px;
    margin: 0;
  }
}

.about-contact-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
}

.about-contact-item {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 15px;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: all 0.3s ease;
  cursor: default;

  &:hover {
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
}

.about-contact-icon {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #ff4840, #fb8681);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  i {
    color: white;
    font-size: 14px;
  }
}

.about-contact-info {
  flex: 1;

  .about-contact-label {
    font-size: 12px;
    color: #666;
    margin-bottom: 2px;
  }

  .about-contact-value {
    font-size: 13px;
    color: #333;
    font-weight: 500;
  }
}

.about-qr-section {
  display: flex;
  justify-content: center;
  gap: 40px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;

  @media (max-width: 768px) {
    gap: 20px;
    flex-wrap: wrap;
  }
}

.about-qr-item {
  text-align: center;
}

.about-qr-image {
  width: 120px;
  height: 120px;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
  }
}

.about-qr-placeholder {
  width: 120px;
  height: 120px;
  background: #f8f9fa;
  border: 2px dashed #ddd;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 10px;
  transition: all 0.3s ease;

  &:hover {
    border-color: #ff4840;
    background: #fff5f4;
  }

  i {
    font-size: 24px;
    color: #999;
  }

  span {
    font-size: 11px;
    color: #666;
    text-align: center;
    line-height: 1.2;
  }
}

.about-qr-label {
  font-size: 12px;
  color: #333;
  font-weight: 600;
  margin-bottom: 2px;
}

.about-qr-desc {
  font-size: 11px;
  color: #666;
  font-weight: 400;
}

// 协议文档链接
.about-docs-links {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-top: 25px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;

  @media (max-width: 768px) {
    gap: 15px;
    flex-wrap: wrap;
  }
}

.about-doc-link {
  font-size: 13px;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid transparent;

  &:hover {
    color: #ff4840;
    background: #fff5f4;
    border-color: #ff4840;
    transform: translateY(-1px);
  }

  @media (max-width: 768px) {
    font-size: 12px;
    padding: 6px 10px;
  }
}
</style>
